<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.processings'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('text.serialNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.customerName"
            :placeholder="$t('menu.customers')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          ></el-input>
        </el-form-item>
        <el-form-item :prop="'categoryName'">
          <el-select
            size="small"
            v-model="searchForm.categoryName"
            :placeholder="$t('product.category')"
            clearable
            filterable
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.specJson"
            :placeholder="$t('product.specJson')"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            v-model="searchForm"
            type="datetime"
            field="handOverAt"
            :start-placeholder="$t('rules.startAt', [$t('text.handOverAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.handOverAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            v-model="searchForm"
            type="datetime"
            field="createAt"
            :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            v-model="searchForm"
            type="datetime"
            field="printAt"
            :start-placeholder="$t('rules.startAt', [$t('text.printAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.printAt')])"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              v-if="!Permit.extendModels().includes('mes')"
              type="primary"
              size="mini"
              :loading="batchProcessedDoing"
              @click="batchProcessed"
              >{{ $t("orderStates.processed") }}</el-button
            >
            <el-button
              v-if="Permit.isFreeEdition()"
              type="success"
              size="mini"
              @click="scanProcessed"
              >扫描{{ $t("orderStates.processed") }}</el-button
            >
            <span v-if="Permit.extendModels().includes('mes')">
              <el-dropdown
                class="mgr10"
                @command="batchAsyncProcessing"
                v-if="Permit.currentTenant().config.mesSchedule == true"
              >
                <el-button type="info" size="mini">
                  {{ $t("action.batchAsyncProcessing") }}
                  <i class="el-icon-caret-bottom el-icon--right" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="printProcessListDiv">
                    {{ $t("order.type") }} - {{ $t("dealOrderTypes.custom") }}
                  </el-dropdown-item>
                  <el-dropdown-item command="printProcessListDiv2">
                    {{ $t("order.type") }} - {{ $t("dealOrderTypes.bulk") }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-button
                v-else
                type="info"
                size="mini"
                :loading="batchAsyncProcessingDoing"
                @click="batchAsyncProcessing('bulk')"
                >同步到生产管理</el-button
              >
            </span>

            <el-button type="default" size="mini" @click="downLoadPDF">
              {{ $t("action.downloadProcessList") }}
            </el-button>

            <el-dropdown class="mgl10" @command="print">
              <el-button type="default" size="mini">
                {{ $t("action.print") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="printProcessListDiv">
                  {{ $t("action.printProcessList") }}1
                </el-dropdown-item>
                <el-dropdown-item command="printProcessListDiv2">
                  {{ $t("action.printProcessList") }}2
                </el-dropdown-item>
                <el-dropdown-item command="printProcessListDiv3">
                  {{ $t("action.printProcessList") }}3
                </el-dropdown-item>
                <el-dropdown-item command="printListDiv">
                  {{ $t("action.printList") }}1
                </el-dropdown-item>
                <el-dropdown-item command="printListDiv2">
                  {{ $t("action.printList") }}2(简版)
                </el-dropdown-item>
                <el-dropdown-item command="printListDiv3">
                  {{ $t("action.printList") }}3
                </el-dropdown-item>
                <el-dropdown-item command="printQrCodeDiv">
                  {{ $t("action.printQrCode") }}1
                </el-dropdown-item>
                <el-dropdown-item command="printQrCode2Div">
                  {{ $t("action.printQrCode") }}2
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="rowBgColor"
        size="mini"
        id="pendingsTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="checkbox" type="checkbox" width="35" />
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <a @click="showRecord(row)">
              {{ row.serialNo }}
            </a>
            <div>
              <state-label :state="row.workflowState">
                {{ $t("orderStates." + row.workflowState) }}
              </state-label>
              <span
                v-if="
                  row.workflowState == 'processing' &&
                  row.receiveQuantity == row.quality &&
                  !Permit.isFreeEdition() &&
                  !Permit.extendModels().includes('mes')
                "
              >
                <el-popover placement="right" width="200" trigger="click">
                  存在待收货记录
                  <i class="el-icon-question" slot="reference"></i>
                </el-popover>
              </span>
            </div>
            <div class="font10">
              {{ $t("menu.customers") }}:{{ row.customerName }}
            </div>
            <div class="font10" v-if="row.replaceDeliver == true">
              {{ $t("order.placeCustomerName") }}:{{ row.placeCustomerName }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="10"
              type="richText"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="specJson"
          :title="$t('product.specJson')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <attribute :content="row.specJson" :number="12" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span :class="Number(row.quantity) > 1 ? 'red font18' : ''">
              {{ row.quantity }}{{ row.unit }}
            </span>
            <div v-if="Permit.isFreeEdition()" class="font10">
              {{ $t("order.dealQuantity") }}: {{ row.dealQuantity }}
            </div>
            <div v-else class="font10">
              {{ $t("order.dealQuantity") }}: {{ row.receiveQuantity }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          width="110"
          sortable
        />

        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        />
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
        <vxe-table-column
          field="printAt"
          :title="$t('order.printAt')"
          width="110"
        />
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="80"
          fixed="right"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="
                !Permit.extendModels().includes('mes') &&
                row.quantity > row.dealQuantity &&
                row.quantity > row.receiveQuantity &&
                ['processing', 'shipped', 'partially'].includes(
                  row.workflowState
                )
              "
              type="text"
              size="mini"
              @click="processedRow(row)"
              >{{ $t("orderStates.processed") }}</el-button
            >
            <div>
              <el-button
                v-if="
                  row.dealQuantity == 0 &&
                  row.receiveQuantity == 0 &&
                  row.workflowState === 'processing'
                "
                type="text"
                size="mini"
                @click="retriveToPenging(row)"
                >{{ $t("action.retriveToPenging") }}</el-button
              >
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- ======== -->
    <drawer
      :title="$t('text.view', [$t('menu.bargains')])"
      :visible.sync="show"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>

    <!-- 单个备货完成 -->
    <el-dialog
      :title="$t('action.processingFinish')"
      :close-on-click-modal="false"
      :visible.sync="processedRowDF"
      width="30%"
    >
      <el-form
        ref="processedRowObjForm"
        :model="processedRowObj"
        label-width="70px"
      >
        <el-form-item
          :label="$t('text.quantity')"
          :prop="'dealQuantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="processedRowObj.dealQuantity"
            :placeholder="processedRowObj._maxDealQuantity"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="processedRowSubmitDoing"
          size="small"
          @click="processedRowSubmit"
        >
          {{ $t("text.submit") }}
        </el-button>
        <el-button size="small" @click="processedRowDF = false">
          {{ $t("text.close") }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 打印生产单 -->
    <div id="printProcessListDiv" style="display: none">
      <div
        v-for="(cr, index) in selectRecords"
        :key="index"
        :style="
          'margin:0 auto 10px; width:650px; text-align:left;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            word-wrap: break-word;
            word-break: break-all;
          "
        >
          <tr>
            <td
              colspan="4"
              style="
                border: 1px solid #dfe5ec;
                text-align: center;
                font-size: 18px;
                font-weight: bold;
                height: 40px;
              "
            >
              {{ Permit.currentTenant().name }}
            </td>
            <td
              rowspan="3"
              colspan="4"
              style="border: 1px solid #dfe5ec; text-align: center"
            >
              <qrcode
                :value="cr.serialNo"
                :options="{ width: 100 }"
                :tag="'img'"
              />
              <div style="font-size: 10px">生产码</div>
              <!-- :value="`${cr.productNo}|${cr.color}|${cr.size}|order|${cr.serialNo}`" -->
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("text.serialNo") }}
            </td>
            <td colspan="3" style="border: 1px solid #dfe5ec">
              {{ cr.serialNo }}
              <small v-if="cr.hurry == true" style="color: red">{{
                $t("order.hurrySimple")
              }}</small>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("menu.customers") }}
            </td>
            <td colspan="3" style="border: 1px solid #dfe5ec">
              {{ cr.customerName }}
              <small>{{ cr.innerSerialNo }}</small>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.productNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec">{{ cr.productNo }}</td>
            <td style="border: 1px solid #dfe5ec">{{ $t("text.createAt") }}</td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.createAt.substring(0, 10) }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("text.handOverAt") }}
            </td>
            <td style="border: 1px solid #dfe5ec; color: red">
              {{ cr.handOverAt }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">{{ $t("product.color") }}</td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.color }}
              <img
                v-if="cr.colorImage != null && cr.colorImage != ''"
                :src="cr.colorImage"
                width="24px"
                height="24px"
                style="width: 24px; height: 24px"
              />
            </td>
            <td style="border: 1px solid #dfe5ec">{{ $t("product.size") }}</td>
            <td style="border: 1px solid #dfe5ec">{{ cr.size }}</td>
            <td style="border: 1px solid #dfe5ec">{{ $t("text.quantity") }}</td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.quantity }}{{ cr.unit }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("menu.categories") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.categoryName }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.brand") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.productBrand }}
            </td>
            <td colspan="2" style="border: 1px solid #dfe5ec"></td>
          </tr>
          <tr v-if="Util.tranStringToArr(cr.images).length != 0">
            <td colspan="2" style="border: 1px solid #dfe5ec">
              <img
                v-if="Util.tranStringToArr(cr.images)[0]"
                style="max-width: 280px; max-height: 400px"
                :src="Util.tranStringToArr(cr.images)[0]"
              />
            </td>
            <td colspan="6" style="border: 1px solid #dfe5ec">
              <img
                v-if="Util.tranStringToArr(cr.images).length > 1"
                style="max-width: 300px; max-height: 400px"
                :src="Util.tranStringToArr(cr.images)[1]"
              />
            </td>
          </tr>
          <tr>
            <td
              colspan="6"
              style="border: 1px solid #dfe5ec; word-break: break-word"
            >
              <div
                v-for="(im, imIndex) in Util.tranStringToArr(cr.images)"
                :key="imIndex"
                style="float: left"
              >
                <img
                  v-if="![0, 1].includes(imIndex)"
                  :src="im"
                  width="80"
                  style="width: 80px; margin-right: 5px; vertical-align: top"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.specJson") }}
            </td>
            <td colspan="5" style="border: 1px solid #dfe5ec">
              {{ Util.tranJSONArrToString(cr.specJson) }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">{{ $t("text.remark") }}</td>
            <td colspan="3" style="border: 1px solid #dfe5ec">
              <raw-html :content="cr.remark" type="richText" />
            </td>
            <td
              colspan="2"
              rowspan="2"
              style="border: 1px solid #dfe5ec; text-align: center"
            >
              <qrcode
                :value="`${cr.productNo}|${cr.color}|${cr.size}||`"
                :options="{ width: 100 }"
                :tag="'img'"
              />
              <div style="font-size: 10px">库存码</div>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.craftwork") }}
            </td>
            <td colspan="3" style="border: 1px solid #dfe5ec">
              <raw-html :content="cr.craftwork" type="richText" />
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 打印生产单 -->
    <div id="printProcessListDiv2" style="display: none">
      <div
        v-for="(cr, index) in selectRecords"
        :key="index"
        :style="
          'margin:0 auto 10px; width:650px; text-align:left;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            word-wrap: break-word;
            word-break: break-all;
          "
        >
          <tr>
            <td
              colspan="4"
              style="
                border: 1px solid #dfe5ec;
                text-align: center;
                font-size: 18px;
                font-weight: bold;
                height: 40px;
              "
            >
              {{ Permit.currentTenant().name }}
            </td>
            <td
              rowspan="3"
              colspan="4"
              style="border: 1px solid #dfe5ec; text-align: center"
            >
              <qrcode
                :value="cr.serialNo"
                :options="{ width: 100 }"
                :tag="'img'"
              />
              <div style="font-size: 10px">生产码</div>
              <!-- :value="`${cr.productNo}|${cr.color}|${cr.size}|order|${cr.serialNo}`" -->
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("text.serialNo") }}
            </td>
            <td colspan="3" style="border: 1px solid #dfe5ec">
              {{ cr.serialNo }}
              <small v-if="cr.hurry == true" style="color: red">{{
                $t("order.hurrySimple")
              }}</small>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("menu.customers") }}
            </td>
            <td colspan="3" style="border: 1px solid #dfe5ec">
              {{ cr.customerName }}
              <small>{{ cr.innerSerialNo }}</small>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.productNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              {{ cr.productNo }}
            </td>
            <td style="border: 1px solid #dfe5ec">{{ $t("text.createAt") }}</td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.createAt.substring(0, 10) }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("text.handOverAt") }}
            </td>
            <td style="border: 1px solid #dfe5ec; color: red">
              {{ cr.handOverAt }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">{{ $t("product.color") }}</td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.color }}
              <img
                v-if="cr.colorImage != null && cr.colorImage != ''"
                :src="cr.colorImage"
                width="24px"
                height="24px"
                style="width: 24px; height: 24px"
              />
            </td>
            <td style="border: 1px solid #dfe5ec">{{ $t("product.size") }}</td>
            <td style="border: 1px solid #dfe5ec">{{ cr.size }}</td>
            <td style="border: 1px solid #dfe5ec">{{ $t("text.quantity") }}</td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.quantity }}{{ cr.unit }}
            </td>
          </tr>
          <tr>
            <td
              colspan="2"
              rowspan="2"
              style="border: 1px solid #dfe5ec; vertical-align: top"
            >
              <div
                v-for="(spec, specIndex) of Util.tranJSONArrToArr(cr.specJson)"
                :key="specIndex"
              >
                {{ spec.name }}：{{ spec.value }}
              </div>
            </td>
            <td colspan="4" style="border: 1px solid #dfe5ec">
              <img
                v-if="Util.tranStringToArr(cr.images)[0]"
                style="max-width: 280px; max-height: 400px"
                :src="Util.tranStringToArr(cr.images)[0]"
              />
            </td>
          </tr>
          <tr>
            <td colspan="4" style="border: 1px solid #dfe5ec">
              <div
                v-for="(im, imIndex) in Util.tranStringToArr(cr.images)"
                :key="imIndex"
                style="float: left"
              >
                <img
                  v-if="![0].includes(imIndex)"
                  :src="im"
                  width="80"
                  style="width: 80px; margin-right: 5px; vertical-align: top"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">{{ $t("text.remark") }}</td>
            <td colspan="3" style="border: 1px solid #dfe5ec">
              <raw-html :content="cr.remark" type="richText" />
            </td>
            <td
              colspan="2"
              rowspan="2"
              style="border: 1px solid #dfe5ec; text-align: center"
            >
              <qrcode
                :value="`${cr.productNo}|${cr.color}|${cr.size}||`"
                :options="{ width: 100 }"
                :tag="'img'"
              />
              <div style="font-size: 10px">库存码</div>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.craftwork") }}
            </td>
            <td colspan="3" style="border: 1px solid #dfe5ec">
              <raw-html :content="cr.craftwork" type="richText" />
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 打印生产单 -->
    <div id="printProcessListDiv3" style="display: none">
      <div
        v-for="(cr, index) in selectRecords"
        :key="index"
        :style="
          'margin:0 auto 10px; width:650px; text-align:left;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            word-wrap: break-word;
            word-break: break-all;
          "
        >
          <tr>
            <td
              colspan="6"
              style="
                border: 1px solid #dfe5ec;
                text-align: center;
                font-size: 18px;
                font-weight: bold;
                height: 40px;
              "
            >
              {{ Permit.currentTenant().name }}
            </td>
          </tr>
          <tr>
            <td
              colspan="6"
              style="border: 1px solid #dfe5ec; text-align: center"
            >
              <barcode :value="cr.serialNo" height="40px"></barcode>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("text.serialNo") }}
            </td>
            <td colspan="5" style="border: 1px solid #dfe5ec">
              {{ cr.serialNo }}
              <small v-if="cr.hurry == true" style="color: red">{{
                $t("order.hurrySimple")
              }}</small>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("menu.customers") }}
            </td>
            <td colspan="5" style="border: 1px solid #dfe5ec">
              {{ cr.customerName }}
              <small>{{ cr.innerSerialNo }}</small>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.productNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec">{{ cr.productNo }}</td>
            <td style="border: 1px solid #dfe5ec">{{ $t("text.quantity") }}</td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.quantity }}{{ cr.unit }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">{{ $t("product.color") }}</td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.color }}
              <img
                v-if="cr.colorImage != null && cr.colorImage != ''"
                :src="cr.colorImage"
                width="24px"
                height="24px"
                style="width: 24px; height: 24px"
              />
            </td>
            <td style="border: 1px solid #dfe5ec">{{ $t("product.size") }}</td>
            <td style="border: 1px solid #dfe5ec">{{ cr.size }}</td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("text.handOverAt") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.handOverAt }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("text.createAt") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cr.createAt.substring(0, 10) }}
            </td>
          </tr>
          <tr v-if="Util.tranStringToArr(cr.images).length != 0">
            <td colspan="2" style="border: 1px solid #dfe5ec">
              <img
                v-if="Util.tranStringToArr(cr.images)[0]"
                style="max-width: 280px; max-height: 400px"
                :src="Util.tranStringToArr(cr.images)[0]"
              />
            </td>
            <td colspan="6" style="border: 1px solid #dfe5ec">
              <img
                v-if="Util.tranStringToArr(cr.images).length > 1"
                style="max-width: 300px; max-height: 400px"
                :src="Util.tranStringToArr(cr.images)[1]"
              />
            </td>
          </tr>
          <tr>
            <td
              colspan="6"
              style="border: 1px solid #dfe5ec; word-break: break-word"
            >
              <div
                v-for="(im, imIndex) in Util.tranStringToArr(cr.images)"
                :key="imIndex"
                style="float: left"
              >
                <img
                  v-if="![0, 1].includes(imIndex)"
                  :src="im"
                  width="80"
                  style="width: 80px; margin-right: 5px; vertical-align: top"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.specJson") }}
            </td>
            <td colspan="5" style="border: 1px solid #dfe5ec">
              {{ Util.tranJSONArrToString(cr.specJson) }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">{{ $t("text.remark") }}</td>
            <td colspan="4" style="border: 1px solid #dfe5ec">
              <raw-html :content="cr.remark" type="richText" />
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.craftwork") }}
            </td>
            <td colspan="4" style="border: 1px solid #dfe5ec">
              <raw-html :content="cr.craftwork" type="richText" />
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div id="printListDiv" style="display: none">
      <div style="width: 100%; text-align: left">
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            word-wrap: break-word;
            word-break: break-all;
          "
        >
          <tr>
            <td style="border: 1px solid #dfe5ec"></td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('product.images'))"
            >
              <strong>{{ $t("product.images") }}</strong>
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.serialNo'))"
            >
              <strong>{{ $t("text.serialNo") }}</strong>
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              <strong>{{ $t("product.productNo") }}</strong>
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.quantity'))"
            >
              <strong>{{ $t("text.quantity") }}</strong>
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.remark'))"
            >
              <strong>{{ $t("product.specJson") }}</strong>
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.remark'))"
            >
              <strong>{{ $t("product.craftwork") }}</strong>
            </td>
            <td
              style="border: 1px solid #dfe5ec; width: 80px"
              v-if="visibleColumnTitles.includes($t('text.handOverAt'))"
            >
              <strong>{{ $t("text.handOverAt") }}</strong>
            </td>
            <td
              style="border: 1px solid #dfe5ec; width: 80px"
              v-if="visibleColumnTitles.includes($t('text.createAt'))"
            >
              <strong>{{ $t("order.giveAt") }}</strong>
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.remark'))"
            >
              <strong>{{ $t("text.remark") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>
                {{ $t("text.quantity") }}/{{ $t("product.specJson") }}/{{
                  $t("order.giveAt")
                }}
              </strong>
            </td>
          </tr>
          <tr v-for="cr in printRecords" :key="cr.id">
            <td style="border: 1px solid #dfe5ec; width: 100px">
              <qrcode
                :value="cr.serialNo"
                :options="{ width: 100 }"
                :tag="'img'"
              />
              <!-- :value="`${cr.productNo}|${cr.color}|${cr.size}|order|${cr.serialNo}`" -->
            </td>
            <td
              style="border: 1px solid #dfe5ec; width: 80px"
              v-if="visibleColumnTitles.includes($t('product.images'))"
            >
              <img :src="cr.firstImage" width="80" />
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.serialNo'))"
            >
              <small v-if="cr.hurry == true" style="color: red">{{
                $t("order.hurrySimple")
              }}</small>
              {{ cr.serialNo }}
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('product.productNo'))"
            >
              {{ cr.productNo }}
              <div>{{ cr.categoryName }}</div>
              <div>{{ cr.color }} {{ cr.size }}</div>
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.quantity'))"
            >
              <span v-if="cr.quantity != 1" style="color: red; font-size: 18px">
                {{ cr.quantity }}{{ cr.unit }}
              </span>
              <span v-else> {{ cr.quantity }}{{ cr.unit }} </span>
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.remark'))"
            >
              <div v-if="cr.specJson != null">
                <div
                  v-for="(sj, index) of Util.tranJSONArrToArr(cr.specJson)"
                  :key="index"
                >
                  {{ sj.name }}:{{ sj.value }}
                </div>
              </div>
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.remark'))"
            >
              <raw-html :content="cr.craftwork" type="richText" />
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.handOverAt'))"
            >
              {{ cr.handOverAt }}
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.createAt'))"
            >
              {{ cr.createAt }}
            </td>
            <td
              style="border: 1px solid #dfe5ec"
              v-if="visibleColumnTitles.includes($t('text.remark'))"
            >
              <raw-html :content="cr.remark" type="richText" />
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              <qrcode
                :value="`${cr.quantity}|${Util.tranJSONArrToArr(cr.specJson)
                  .map((c) => c.name + '：' + c.value)
                  .join('；')}|${cr.createAt}`"
                :options="{ width: 100 }"
                :tag="'img'"
              />
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div id="printListDiv2" style="display: none">
      <div style="width: 100%; text-align: left">
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            word-wrap: break-word;
            word-break: break-all;
          "
        >
          <tr align="center">
            <td style="border: 1px solid #dfe5ec">{{ $t("text.qrCode") }}</td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.images") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("text.serialNo") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.productNo") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              <strong>{{ $t("text.remark") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">{{ $t("text.qrCode") }}</td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.images") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("text.serialNo") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec">
              <strong>{{ $t("product.productNo") }}</strong>
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              <strong>{{ $t("text.remark") }}</strong>
            </td>
          </tr>
          <tr v-for="i in Math.ceil(selectedLength / 2)" :key="i">
            <template v-if="i - 1 < Math.ceil(selectedLength / 2)">
              <td style="border: 1px solid #dfe5ec; width: 100px">
                <qrcode
                  :value="selectRecords[i - 1].serialNo"
                  :options="{ width: 100 }"
                  :tag="'img'"
                />
              </td>
              <td style="border: 1px solid #dfe5ec; width: 80px">
                <img :src="selectRecords[i - 1].firstImage" width="80" />
              </td>
              <td style="border: 1px solid #dfe5ec; width: 200px">
                <small
                  v-if="selectRecords[i - 1].hurry == true"
                  style="color: red"
                  >{{ $t("order.hurrySimple") }}</small
                >
                <span style="font-size: 14px">
                  {{ selectRecords[i - 1].serialNo }}
                </span>
                <div style="font-size: 18px; color: red">
                  {{ $t("text.quantity") }}:{{ selectRecords[i - 1].quantity
                  }}{{ selectRecords[i - 1].unit }}
                </div>
                <div style="font-size: 10px">
                  交期:{{ selectRecords[i - 1].handOverAt }}
                </div>
                <div style="font-size: 10px">
                  下单:{{ selectRecords[i - 1].createAt }}
                </div>
              </td>
              <td style="border: 1px solid #dfe5ec; width: 160px">
                {{ selectRecords[i - 1].productNo }}
                <div>
                  {{ selectRecords[i - 1].color }}
                  {{ selectRecords[i - 1].size }}
                </div>
              </td>
              <td style="border: 1px solid #dfe5ec">
                <raw-html
                  :content="selectRecords[i - 1].remark"
                  type="richText"
                  style="font-size: 14px"
                />
              </td>
            </template>
            <template
              v-if="
                i - 1 + Math.ceil(selectedLength / 2) < selectRecords.length
              "
            >
              <td style="border: 1px solid #dfe5ec; width: 100px">
                <qrcode
                  :value="
                    selectRecords[i - 1 + Math.ceil(selectedLength / 2)]
                      .serialNo
                  "
                  :options="{ width: 100 }"
                  :tag="'img'"
                />
              </td>
              <td style="border: 1px solid #dfe5ec; width: 80px">
                <img
                  :src="
                    selectRecords[i - 1 + Math.ceil(selectedLength / 2)]
                      .firstImage
                  "
                  width="80"
                />
              </td>
              <td style="border: 1px solid #dfe5ec; width: 200px">
                <small
                  v-if="
                    selectRecords[i - 1 + Math.ceil(selectedLength / 2)]
                      .hurry == true
                  "
                  style="color: red"
                  >{{ $t("order.hurrySimple") }}</small
                >
                <span style="font-size: 14px">{{
                  selectRecords[i - 1 + Math.ceil(selectedLength / 2)].serialNo
                }}</span>
                <div style="font-size: 18px; color: red">
                  {{ $t("text.quantity") }}:{{
                    selectRecords[i - 1 + Math.ceil(selectedLength / 2)]
                      .quantity
                  }}{{
                    selectRecords[i - 1 + Math.ceil(selectedLength / 2)].unit
                  }}
                </div>
                <div style="font-size: 10px">
                  交期:{{
                    selectRecords[i - 1 + Math.ceil(selectedLength / 2)]
                      .handOverAt
                  }}
                </div>
                <div style="font-size: 10px">
                  下单:{{
                    selectRecords[i - 1 + Math.ceil(selectedLength / 2)]
                      .createAt
                  }}
                </div>
              </td>
              <td style="border: 1px solid #dfe5ec; width: 160px">
                {{
                  selectRecords[i - 1 + Math.ceil(selectedLength / 2)].productNo
                }}
                <div>
                  {{
                    selectRecords[i - 1 + Math.ceil(selectedLength / 2)].color
                  }}
                  {{
                    selectRecords[i - 1 + Math.ceil(selectedLength / 2)].size
                  }}
                </div>
              </td>
              <td style="border: 1px solid #dfe5ec">
                <raw-html
                  :content="
                    selectRecords[i - 1 + Math.ceil(selectedLength / 2)].remark
                  "
                  type="richText"
                  style="font-size: 14px"
                />
              </td>
            </template>

            <!-- <template v-if="(i - 1) * 2 <= selectRecords.length">
              <td style="border: 1px solid #dfe5ec; width: 100px">
                <qrcode
                  :value="selectRecords[(i - 1) * 2].serialNo"
                  :options="{ width: 100 }"
                  :tag="'img'"
                />
              </td>
              <td style="border: 1px solid #dfe5ec; width: 80px">
                <img :src="selectRecords[(i - 1) * 2].firstImage" width="80" />
              </td>
              <td style="border: 1px solid #dfe5ec; width: 200px">
                <small
                  v-if="selectRecords[(i - 1) * 2].hurry == true"
                  style="color: red"
                  >{{ $t("order.hurrySimple") }}</small
                >
                <span style="font-size: 14px">
                  {{ selectRecords[(i - 1) * 2].serialNo }}
                </span>
                <div style="font-size: 18px; color: red">
                  {{ $t("text.quantity") }}:{{
                    selectRecords[(i - 1) * 2].quantity
                  }}{{ selectRecords[(i - 1) * 2].unit }}
                </div>
                <div style="font-size: 10px">
                  交期:{{ selectRecords[(i - 1) * 2].handOverAt }}
                </div>
                <div style="font-size: 10px">
                  下单:{{ selectRecords[(i - 1) * 2].createAt }}
                </div>
              </td>
              <td style="border: 1px solid #dfe5ec; width: 160px">
                {{ selectRecords[(i - 1) * 2].productNo }}
                <div>
                  {{ selectRecords[(i - 1) * 2].color }}
                  {{ selectRecords[(i - 1) * 2].size }}
                </div>
              </td>
              <td style="border: 1px solid #dfe5ec">
                <raw-html
                  :content="selectRecords[(i - 1) * 2].remark"
                  type="richText"
                  style="font-size: 14px"
                />
              </td>
            </template>
            <template v-if="(i - 1) * 2 + 1 < selectRecords.length">
              <td style="border: 1px solid #dfe5ec; width: 100px">
                <qrcode
                  :value="selectRecords[(i - 1) * 2 + 1].serialNo"
                  :options="{ width: 100 }"
                  :tag="'img'"
                />
              </td>
              <td style="border: 1px solid #dfe5ec; width: 80px">
                <img
                  :src="selectRecords[(i - 1) * 2 + 1].firstImage"
                  width="80"
                />
              </td>
              <td style="border: 1px solid #dfe5ec; width: 200px">
                <small
                  v-if="selectRecords[(i - 1) * 2 + 1].hurry == true"
                  style="color: red"
                  >{{ $t("order.hurrySimple") }}</small
                >
                <span style="font-size: 14px">{{
                  selectRecords[(i - 1) * 2 + 1].serialNo
                }}</span>
                <div style="font-size: 18px; color: red">
                  {{ $t("text.quantity") }}:{{
                    selectRecords[(i - 1) * 2 + 1].quantity
                  }}{{ selectRecords[(i - 1) * 2 + 1].unit }}
                </div>
                <div style="font-size: 10px">
                  交期:{{ selectRecords[(i - 1) * 2 + 1].handOverAt }}
                </div>
                <div style="font-size: 10px">
                  下单:{{ selectRecords[(i - 1) * 2 + 1].createAt }}
                </div>
              </td>
              <td style="border: 1px solid #dfe5ec; width: 160px">
                {{ selectRecords[(i - 1) * 2 + 1].productNo }}
                <div>
                  {{ selectRecords[(i - 1) * 2 + 1].color }}
                  {{ selectRecords[(i - 1) * 2 + 1].size }}
                </div>
              </td>
              <td style="border: 1px solid #dfe5ec">
                <raw-html
                  :content="selectRecords[(i - 1) * 2 + 1].remark"
                  type="richText"
                  style="font-size: 14px"
                />
              </td>
            </template> -->
          </tr>
        </table>
      </div>
    </div>

    <div id="printListDiv3" style="display: none">
      <div
        style="
          width: 100%;
          text-align: center;
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 10px;
        "
      >
        生产通知单
      </div>
      <div style="width: 100%; text-align: left">
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #444444;
            word-wrap: break-word;
            word-break: break-all;
          "
        >
          <tr>
            <td style="border: 1px solid #444444">
              <strong>{{ $t("product.images") }}</strong>
            </td>
            <td style="border: 1px solid #444444">
              <strong>{{ $t("text.serialNo") }}</strong>
            </td>
            <td style="border: 1px solid #444444">
              <strong>{{ $t("product.productNo") }}</strong>
            </td>
            <td style="border: 1px solid #444444">
              <strong>{{ $t("text.quantity") }}</strong>
            </td>
            <td style="border: 1px solid #444444">
              <strong>{{ $t("text.handOverAt") }}</strong>
            </td>
            <td style="border: 1px solid #444444">
              <strong>{{ $t("order.giveAt") }}</strong>
            </td>

            <td style="border: 1px solid #444444">
              <strong>
                {{ $t("text.handle") }}
              </strong>
            </td>
            <td style="border: 1px solid #444444">
              <strong>
                {{ $t("menu.customers") }}
              </strong>
            </td>
            <td style="border: 1px solid #444444">
              <strong>{{ $t("text.remark") }}</strong>
            </td>
          </tr>
          <tr v-for="cr in printRecords" :key="cr.id">
            <td style="border: 1px solid #444444; width: 80px">
              <img :src="cr.firstImage" width="80" />
            </td>
            <td style="border: 1px solid #444444; min-width: 120px">
              <small v-if="cr.hurry == true" style="color: red">{{
                $t("order.hurrySimple")
              }}</small>
              {{ cr.serialNo }}
            </td>
            <td style="border: 1px solid #444444; min-width: 100px">
              {{ cr.productNo }}
              <div>{{ cr.categoryName }}</div>
              <div>{{ cr.color }} {{ cr.size }}</div>
            </td>
            <td style="border: 1px solid #444444; min-width: 80px">
              <span v-if="cr.quantity != 1" style="color: red; font-size: 18px">
                {{ cr.quantity }}{{ cr.unit }}
              </span>
              <span v-else> {{ cr.quantity }}{{ cr.unit }} </span>
            </td>

            <td style="border: 1px solid #444444; min-width: 100px">
              {{ cr.handOverAt }}
            </td>
            <td style="border: 1px solid #444444; min-width: 100px">
              {{ cr.createAt }}
            </td>

            <td style="border: 1px solid #444444; width: 100px">
              {{ cr.shopName }}
              <div>{{ cr.ownerName }}</div>
            </td>
            <td style="border: 1px solid #444444; width: 100px">
              {{ cr.customerName }}
            </td>
            <td style="border: 1px solid #444444; min-width: 120px">
              <raw-html :content="cr.remark" type="richText" />
            </td>
          </tr>
        </table>
        <div>温馨提示：所有报价不含税</div>
      </div>
    </div>

    <div id="printQrCodeDiv" style="display: none">
      <div v-for="(item, index) in selectRecords" :key="index">
        <div
          :style="{ 'page-break-before': index != 0 ? 'always' : '' }"
          align="center"
        >
          <table
            style="
              border-collapse: collapse;
              border: 1px solid #dfe5ec;
              word-wrap: break-word;
              word-break: break-all;
              text-align: center;
              font-size: 12px;
            "
          >
            <tbody>
              <tr style="border: 1px solid #dfe5ec">
                <td align="center">
                  <qrcode
                    :value="item.serialNo"
                    :options="{ width: 100 }"
                    :tag="'img'"
                  />
                  <!-- :value="`${item.productNo}|${item.color}|${item.size}|order|${item.serialNo}`" -->
                </td>
              </tr>
              <tr style="border: 1px solid #dfe5ec">
                <td>
                  {{ item.serialNo }}
                  <div>{{ item.productNo }}</div>
                  <div>{{ item.color }}-{{ item.size }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div id="printQrCode2Div" style="display: none">
      <div v-for="(item, index) in selectRecords" :key="index">
        <div
          :style="{ 'page-break-before': index != 0 ? 'always' : '' }"
          align="center"
        >
          <table
            style="
              border-collapse: collapse;
              border: 1px solid #dfe5ec;
              word-wrap: break-word;
              word-break: break-all;
              text-align: center;
              font-size: 12px;
            "
          >
            <tbody>
              <tr style="border: 1px solid #dfe5ec">
                <td align="center">
                  <qrcode
                    :value="item.serialNo"
                    :options="{ width: 100 }"
                    :tag="'img'"
                  />
                  <!-- :value="`${item.productNo}|${item.color}|${item.size}|order|${item.serialNo}`" -->
                </td>
              </tr>
              <tr style="border: 1px solid #dfe5ec">
                <td>
                  {{ item.serialNo }}
                  <div>{{ item.productNo }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('orderStates.processed')"
      width="800px"
      v-if="scanProcessedDF"
      :visible.sync="scanProcessedDF"
      :close-on-click-modal="false"
    >
      <scan-processed
        @close="scanProcessedDF = false"
        @updateData="scanProcessedClose"
      ></scan-processed>
    </el-dialog>

    <el-dialog
      :title="$t('action.print')"
      :close-on-click-modal="false"
      :visible.sync="printDF"
      width="80%"
    >
      <vxe-table
        :data="printRecords"
        ref="printRecordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            {{ row.serialNo }}
            <div>
              <state-label :state="row.workflowState">
                {{ $t("orderStates." + row.workflowState) }}
              </state-label>
              <span
                v-if="
                  row.workflowState == 'processing' &&
                  row.receiveQuantity == row.quality &&
                  !Permit.isFreeEdition() &&
                  !Permit.extendModels().includes('mes')
                "
              >
                <el-popover placement="right" width="200" trigger="click">
                  存在待收货记录
                  <i class="el-icon-question" slot="reference"></i>
                </el-popover>
              </span>
            </div>
            <div class="font10">
              {{ $t("menu.customers") }}:{{ row.customerName }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="10"
              type="richText"
            />
            <div>
              <attribute :content="row.specJson" :number="6" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit }}
            <div v-if="Permit.isFreeEdition()" class="font10">
              {{ $t("order.dealQuantity") }}: {{ row.dealQuantity }}
            </div>
            <div v-else class="font10">
              {{ $t("order.dealQuantity") }}: {{ row.receiveQuantity }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          width="110"
          sortable
        />

        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        />
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
        <vxe-table-column field="action" :title="$t('text.action')" width="50">
          <template v-slot="{ row, rowIndex }">
            <el-button
              type="text"
              size="mini"
              class="mgr10"
              @click="remove(row, rowIndex)"
              >{{ $t("text.remove") }}
            </el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          size="small"
          @click="printSubmit('printListDiv')"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="printDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('orderStates.processed')"
      :close-on-click-modal="false"
      :visible.sync="batchProcessedDF"
      width="30%"
    >
      <div slot="footer" class="dialog-footer">
        <div class="center font18 mgb20">存在未打印的订单，确定生产完成？</div>
        <el-button
          type="primary"
          plain
          size="small"
          @click="batchProcessedFun"
          >{{ $t("order.confirm") }}</el-button
        >
        <el-button size="small" @click="batchProcessedDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Barcode from "vue-barcode";
import Qrcode from "@chenfengyuan/vue-qrcode";
import RawHtml from "@/components/RawHtml";
import DateRange from "@/components/DateRange";
import Order from "@/api/order.js";
import Shop from "@/api/shop.js";

import Show from "../bargains/showOrder.vue";
import ScanProcessed from "./scanProcessed";
import Category from "@/api/category";
export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    RawHtml,
    Qrcode,
    Show,
    ScanProcessed,
    Barcode,
  },

  data() {
    return {
      Util: Util,
      sorter: {
        sortBy: "orders_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "orders_productNo",
        handOverAt: "orders_handOverAt",
      },
      narrows: [
        [
          {
            label: this.$t("order.nearRange"),
            items: Order.nearRange,
          },
          {
            label: this.$t("order.passRange"),
            items: Order.passRange,
          },
        ],
        [
          {
            label: this.$t("text.workflowState"),
            items: [
              {
                label: "生产处理中",
                key: "unFinshed",
                condition: {
                  workflowStates: ["processing", "shipped", "partially"],
                  dealt: "no",
                },
              },
              {
                label: this.$t("orderStates.canceled"),
                key: "canceled",
                condition: {
                  workflowStates: ["canceled"],
                  dealt: "no",
                },
              },
              {
                label: this.$t("orderStates.processed"),
                key: "processed",
                condition: {
                  workflowStates: ["processed"],
                  dealt: "no",
                },
              },
            ],
          },
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("order.hurry"),
                key: "hurryYes",
                condition: { hurry: "yes" },
              },
              {
                label: this.$t("text.unPrint"),
                key: "unPrint",
                condition: { print: "no" },
              },
              {
                label: this.$t("action.retriveToPenging"),
                key: "retriveToPendingYes",
                condition: { retriveToPending: "yes" },
              },
            ],
          },
        ],
        [
          {
            label: "尺码货号排序",
            items: [
              {
                label: "尺码升序-货号升序",
                key: "ascAsc",
                condition: {
                  sortProductNoSize: "ascAsc",
                },
              },
              {
                label: "尺码升序-货号降序",
                key: "ascDesc",
                condition: {
                  sortProductNoSize: "ascDesc",
                },
              },
              {
                label: "尺码降序-货号升序",
                key: "descAsc",
                condition: {
                  sortProductNoSize: "descAsc",
                },
              },

              {
                label: "尺码降序-货号降序",
                key: "descDesc",
                condition: {
                  sortProductNoSize: "descDesc",
                },
              },
            ],
          },
        ],
      ],
      initFilter: "unFinshed",
      searchForm: {
        serialNo: null,
        customerName: null,
        productNo: null,
        categoryName: null,
        color: null,
        size: null,
        handOverAtStartAt: null,
        handOverAtEndAt: null,
        createAtStartAt: null,
        createAtEndAt: null,
        printAtStartAt: null,
        printAtEndAt: null,
        specJson: null,
      },
      shops: [],
      shopsInv: [],
      categories: [],
      //
      currentRowIdx: null,
      //
      show: false,
      currentRowId: null,
      // 批量生产完成
      batchProcessedDoing: false,
      canBatchProcessedRecords: [],
      batchProcessedDF: false,
      // 单个生产完成
      currentRowIdx: null,
      processedRowDF: false,
      processedRowObj: {
        id: null,
        dealQuantity: null,
        _maxDealQuantity: null,
      },
      processedRowSubmitDoing: false,
      //
      scanProcessedDF: false,
      //
      batchAsyncProcessingDoing: false,
      //
      printDF: false,
      visibleColumnTitles: [],
      printRecords: [],
    };
  },
  computed: {
    implicit() {
      return {
        dealTypes: ["manufacture"],
      };
    },
    selectedLength() {
      return this.selectRecords.length;
    },
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    Shop.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.shops = res.data;
        self.shopsInv = res.data.filter((s) => s.isInventory === true);
      } else {
        self.sysError();
      }
    });
    self.getCategory();
  },
  methods: {
    getCategory() {
      const self = this;
      Category.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.categories = res.data;
        } else {
          self.sysError();
        }
      });
    },

    batchAsyncProcessing(type) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.batchAsyncProcessingDoing = true;
      Order.batchAsyncProcessing(
        self.selectRecords.map((c) => {
          return { id: c.id, type: type };
        })
      ).then(function (res) {
        self.batchAsyncProcessingDoing = false;
        if (res.status === 200) {
          self.sysResults(res.data, self.$t("prompt.asyncSuccess"));
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    //
    scanProcessed() {
      this.scanProcessedDF = true;
    },
    scanProcessedClose() {
      this.scanProcessedDF = false;
      this.loadData();
    },
    //
    print(type) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.printRecords = self.selectRecords;
      if (type == "printListDiv") {
        let visibleColumn = self.$refs.recordsTable.getColumns();
        self.visibleColumnTitles = visibleColumn.map((c) => c.title);
        self.printDF = true;
        return;
      }
      self.printSubmit(type);
    },
    remove(row, rowIndex) {
      this.printRecords.splice(rowIndex, 1);
    },
    printSubmit(type) {
      const self = this;
      let ids = [];
      if (type == "printListDiv") {
        ids = self.printRecords.map((c) => c.id);
      } else {
        ids = self.selectRecords.map((c) => c.id);
      }
      Order.batchPrint(ids).then(function (res) {
        if (res.status === 200) {
          self.loadData();
          self.printFunction(type);
          self.$message({
            message: self.$t("prompt.printSuccess"),
            type: "success",
          });
          self.printDF = false;
          self.clearSelected();
        } else {
          self.sysError();
        }
      });
    },
    //
    downLoadPDF() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      Order.downloadPdf(self.selectRecords.map((c) => c.id)).then(function (
        res
      ) {
        if (res.data.code === 200) {
          self.loadData();
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 撤回待处理
    retriveToPenging(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmRetriveToPenging"))) {
        Order.manufactureRepending(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.dealSuccess"),
              type: "success",
            });
            self.loadData();
            self.$eventHub.$emit("orderManufactureRepending");
          } else {
            self.sysError();
          }
        });
      }
    },
    // 单个生产完成
    processedRow(row, rowIndex) {
      const self = this;
      self.processedRowObj.id = row.id;
      if (self.Permit.isFreeEdition()) {
        self.processedRowObj.dealQuantity = row.quantity - row.dealQuantity;
        self.processedRowObj._maxDealQuantity = row.quantity - row.dealQuantity;
      } else {
        self.processedRowObj.dealQuantity = row.quantity - row.receiveQuantity;
        self.processedRowObj._maxDealQuantity =
          row.quantity - row.receiveQuantity;
      }
      self.processedRowSubmitDoing = false;
      self.processedRowDF = true;
    },
    processedRowSubmit() {
      const self = this;
      self.$refs.processedRowObjForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(self.processedRowObj.dealQuantity) ||
            self.processedRowObj.dealQuantity === "0" ||
            self.processedRowObj.dealQuantity >
              self.processedRowObj._maxDealQuantity
          ) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.processedRowSubmitDoing = true;
          Order.manufacturePartDeal(self.processedRowObj).then(function (res) {
            self.processedRowSubmitDoing = false;
            self.processedRowDF = false;
            if (res.status == 200) {
              self.loadData();
              self.sysResult(res.data);
              self.$eventHub.$emit("orderManufacturePartDeal");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //批量生产完成
    batchProcessed() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.canBatchProcessedRecords = [];
      for (const row of self.selectRecords) {
        let dealQuantity = 0;
        if (self.Permit.isFreeEdition()) {
          dealQuantity = row.dealQuantity;
        } else {
          dealQuantity = row.receiveQuantity;
        }
        if (
          row.quantity > dealQuantity &&
          ["processing", "shipped", "partially"].includes(row.workflowState)
        ) {
          self.canBatchProcessedRecords.push(row);
        }
      }
      if (self.canBatchProcessedRecords.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneDataUnProcessfinish"),
          type: "warning",
        });
        return;
      }
      const unPrintRecords = self.canBatchProcessedRecords.filter(
        (r) => r.printAt == null
      );
      if (unPrintRecords.length !== 0 && self.Permit.isFreeEdition()) {
        self.batchProcessedDF = true;
      } else {
        self.batchProcessedFun();
      }
    },
    batchProcessedFun() {
      const self = this;
      self.batchProcessedDoing = true;
      Order.batchProcessed(self.canBatchProcessedRecords.map((s) => s.id)).then(
        function (res) {
          self.batchProcessedDoing = false;
          if (res.status === 200) {
            self.sysResults(res.data, self.$t("prompt.dealSuccess"));
            self.loadData();
            self.$eventHub.$emit("orderBatchProcessed");
            self.batchProcessedDF = false;
          } else {
            self.sysError();
          }
        }
      );
    },

    showRecord(order) {
      this.currentRowId = order.id;
      this.show = true;
    },
    //======
    dataProvider(params) {
      return Order.search(params);
    },
    isNear(row) {
      //定义近交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (
        !noColorWorkflowStates.includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (
          Util.dateDiff(row.handOverAt, new Date()) <=
            this.Permit.currentTenant().config.nearDays &&
          Util.dateDiff(row.handOverAt, new Date()) > 0
        ) {
          return true;
        }
      }
      return false;
    },
    isPass(row) {
      //定义过交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (
        !noColorWorkflowStates.includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (Util.dateDiff(row.handOverAt, new Date()) <= 0) {
          return true;
        }
      }
      return false;
    },

    // 可选
    checCheckboxMethod({ row }) {
      // if (this.Permit.extendModels().includes("mes")) {
      //   return true;
      // }
      // let dealQuantity = 0;
      // if (this.Permit.isFreeEdition()) {
      //   dealQuantity = row.dealQuantity;
      // } else {
      //   dealQuantity = row.receiveQuantity;
      // }
      // if (
      //   !this.Permit.extendModels().includes("mes") &&
      //   row.quantity > dealQuantity &&
      //   ["processing", "shipped", "partially"].includes(row.workflowState)
      // ) {
      //   return true;
      // }
      // return false;
      return true;
    },
  },
};
</script>
